// extracted by mini-css-extract-plugin
export var cell = "HomeAwayColumns-module--cell--29345";
export var columns = "HomeAwayColumns-module--columns--91cf1";
export var container = "HomeAwayColumns-module--container--b80c1";
export var divider = "HomeAwayColumns-module--divider--18501";
export var noHeaderBorder = "HomeAwayColumns-module--noHeaderBorder--03b38";
export var single = "HomeAwayColumns-module--single--f09b6";